import deploymentEnvironment from "../../client-utils/url/deploymentEnvironment.util.js";
import isClientSide from "../../common-utils/environment/isClientSide.util.js";
export const useDeploymentEnvironmentHook = () => (isClientSide() ? deploymentEnvironment() : undefined);
export default useDeploymentEnvironmentHook;
